import Vue from 'vue';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function getVueInstance(el) {
  var elem = el;
  return elem.__vue__;
}
function isHtmlElement(el) {
  return el instanceof HTMLElement;
}
function hasCallback(el) {
  var elem = el;
  var binding = elem.binding;
  return binding && (binding.onView || binding.onExit || binding.afterTransition) || el.getAttribute('ltr-id') !== undefined;
}
function isVueComponent(el) {
  return getVueInstance(el) !== undefined;
}
function isLazyTransitionComponent(el) {
  if (isVueComponent(el)) {
    var instance = getVueInstance(el);

    if (instance) {
      if (typeof instance.$data.lazyTransitionShow === 'boolean') {
        return true;
      }
    }
  }

  return false;
} // helper method to add and remove classes from an element

function addAndRemoveCssClass(el, addList, removeList) {
  if (addList !== undefined && addList.length !== 0) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(addList));
  }

  if (removeList !== undefined && removeList.length !== 0) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(removeList));
  }
}
function makeStr(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;

  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

function addBindingProperties(el, binding) {
  var obBind = {
    transition: Object.create(null),
    isVue: true
  };
  var bindVal = binding.value;

  if (typeof bindVal === 'string') {
    obBind.transition = bindVal;
  } else if (_typeof(bindVal) === 'object') {
    obBind.transition = bindVal.transition;
    obBind.onView = bindVal.onView;
    obBind.onExit = bindVal.onExit;
  }

  if (binding.modifiers.manual) {
    obBind.isVue = false;
  }

  el.binding = obBind;
  return obBind;
}

function prepareAndWatch(el, binding, node) {
  var element = el;
  var bindVal = addBindingProperties(element, binding); // if the element is not a vue component, observe with context

  if (isHtmlElement(el) && !isVueComponent(el)) {
    var rootVue = node.context;

    if (rootVue) {
      rootVue.$lazyObserver.startObserving(element, bindVal);
    }
  } else if (isVueComponent(el)) {
    var _node$componentInstan;

    // if its a component, observe with component
    (_node$componentInstan = node.componentInstance) === null || _node$componentInstan === void 0 ? void 0 : _node$componentInstan.$lazyObserver.startObserving(element, bindVal);
  }
}

var lazyAnimateDirective = function lazyAnimateDirective(app) {
  return app.directive('lazytransition', {
    inserted: function inserted(el, binding, vnode) {
      if (el.getAttribute('lazy-observing') !== 'true') {
        prepareAndWatch(el, binding, vnode);
      }
    }
  });
};
var lazyAnimateGroup = function lazyAnimateGroup(app) {
  return app.directive('lazytransition-group', {
    inserted: function inserted(el, binding, vnode) {
      if (el.hasChildNodes()) {
        var numberOfChildren = el.children.length;

        for (var i = 0; i < numberOfChildren; i++) {
          var elm = el.children.item(i);
          var instance = getVueInstance(elm);
          var vNode = instance ? instance.$vnode : vnode;

          if (elm.getAttribute('lazy-observing') !== 'true') {
            prepareAndWatch(elm, binding, vNode);
          }
        }
      }
    }
  });
};
var lazyTransitionRoot = function lazyTransitionRoot(app) {
  return app.directive('lazytransition-root', {
    bind: function bind(el, binding, vnode) {
      var context = vnode.context;
      var obs = context === null || context === void 0 ? void 0 : context.$lazyObserver;
      var bindVal = binding.value;
      var obsName = bindVal ? bindVal.observer : undefined;
      if (obs) if (bindVal) {
        if (obsName && obsName.length > 0) obs.createObserver(obsName, el);
      } else obs.createObserver('default', el);
    }
  });
};

var script = Vue.extend({
  name: 'LazyTransition',
  // vue component name
  props: {
    name: {
      required: false,
      default: '',
      type: String
    },
    height: {
      required: false,
      default: 200,
      type: Number
    }
  },
  data: function data() {
    return {
      lazyTransitionShow: false
    };
  },
  mounted: function mounted() {
    var el = this.$refs.animateditem;
    this.$lazyObserver.startObserving(el, {});
  },
  beforeDestroy: function beforeDestroy() {
    var el = this.$refs.animateditem;
    this.$lazyObserver.stopObserving(el);
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "animateditem",
    staticClass: "lazy-animated",
    style: {
      minHeight: _vm.height + 'px'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.name
    }
  }, [_vm.lazyTransitionShow ? _vm._t("default", [_vm._v(" DEFAULT ")]) : _vm._e()], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var ObserverFactory = /*#__PURE__*/function () {
  function ObserverFactory(config) {
    _classCallCheck(this, ObserverFactory);

    _defineProperty(this, "observerMap", new Map());

    _defineProperty(this, "lastConfig", void 0);

    this.lastConfig = config;
  }

  _createClass(ObserverFactory, [{
    key: "has",
    value: function has(name) {
      return this.observerMap.has(name);
    }
  }, {
    key: "getObserver",
    value: function getObserver(name) {
      return this.observerMap.get(name);
    }
  }, {
    key: "createObserver",
    value: function createObserver(name, config, obsFn) {
      // save last Observer configuration
      if (config) this.lastConfig = config; // remove existing observer if it exists

      this.removeObserver(name); // if an observer function is provided, add a new observer wit that function

      if (obsFn) this.observerMap.set(name, new IntersectionObserver(obsFn, config === null || config === void 0 ? void 0 : config.options));
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(name) {
      var storedObserver = this.observerMap.get(name);

      if (storedObserver) {
        storedObserver.takeRecords().forEach(function (entry) {
          return entry.target.removeAttribute('lazy-observing');
        });
        storedObserver.disconnect();
        this.observerMap.delete(name);
      }
    }
  }, {
    key: "deleteAll",
    value: function deleteAll() {
      var _iterator = _createForOfIteratorHelper(this.observerMap.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          this.removeObserver(key.toString());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "config",
    get: function get() {
      return this.lastConfig;
    }
  }]);

  return ObserverFactory;
}();

function startTransition(element, transition, stage) {
  var isVue = element.binding.isVue;

  if (isVue) {
    addAndRemoveCssClass(element, [transition + "-".concat(stage, "-active")], [transition + "-".concat(stage)]);
  } else {
    addAndRemoveCssClass(element, [transition]);
  }
} // Run when element is in view
// @TODO (Make Replaceable)


function handleElementInView(entry, config, obSer) {
  // get the element
  var elm = entry.target;

  if (entry.isIntersecting) {
    if (entry.intersectionRatio >= config.intersectionRatio) {
      var transition = elm.binding.transition;
      var id = elm.getAttribute('ltr-id');
      var fnTpl = id ? obSer.fnMap.get(id) : undefined;

      try {
        if (isLazyTransitionComponent(elm)) {
          getVueInstance(elm).$data.lazyTransitionShow = true;
          elm.removeAttribute('style');
        } else {
          // if there is a transition, start transition
          if (transition && transition.length !== 0 && elm.transitionStage === 0) {
            startTransition(elm, transition, 'enter');
          }

          if (hasCallback(elm) && id) {
            if (obSer.fnMap.has(id)) {
              if (fnTpl) {
                if (fnTpl.onView) fnTpl.onView(elm);
              }
            }

            elm.removeAttribute('ltr-id');
          }
        }
      } finally {
        // Stop observing after object is in view and transition is done
        obSer.stopObserving(elm);
      } // const rootBounds = entry.rootBounds
      // if (rootBounds) {
      //   if (entry.intersectionRect.top <= entry.rootBounds!.top + 80) {
      //     startTransition(elm, transition!, 'leave')
      //     obSer.stopObserving(elm)
      //   }
      // }

    }
  }
} // add and remove vue transition classes

function addTransitionEvents(el, state, fnMap) {
  var bn = el.binding;
  var tr = bn.transition;
  var fn = fnMap.has(el.trId) ? fnMap.get(el.trId) : undefined;
  var fnEnd = fn ? fn.afterTransition : undefined;
  if (!bn || !tr) return;
  var trn = tr + '-' + state;
  var trnActive = trn + '-active';
  var trnTo = trn + '-to';

  if (tr.length !== 0) {
    addAndRemoveCssClass(el, [trn]);
    el.transitionStage = 0;
    el.addEventListener('transitionstart', function () {
      addAndRemoveCssClass(el, [trnTo], [trn]);
      el.transitionStage = 1;
    }, {
      once: true
    });
    el.addEventListener('transitionrun', function () {
      addAndRemoveCssClass(el, [trnActive]);
      el.transitionStage = 2;
    }, {
      once: true
    });
    el.addEventListener('transitionend', function () {
      addAndRemoveCssClass(el, undefined, [trn, trnActive, trnTo]);
      el.transitionStage = 3;
      if (fnEnd) fnEnd(el);
    }, {
      once: true
    });
  }
}

var ObserverService = /*#__PURE__*/function () {
  function ObserverService(config) {
    var _this = this;

    _classCallCheck(this, ObserverService);

    _defineProperty(this, "_obKey", void 0);

    _defineProperty(this, "_factory", void 0);

    _defineProperty(this, "obsFn", void 0);

    _defineProperty(this, "_fnMap", new Map());

    this._factory = new ObserverFactory(config);
    this._obKey = 'default';

    this.obsFn = function (entries) {
      entries.forEach(function (entry) {
        handleElementInView(entry, config, _this);
      });
    };

    this.factory.createObserver(this.observerKey, config, this.obsFn);
  } //return observer with active key from the observer factory


  _createClass(ObserverService, [{
    key: "changeObserver",
    // change observer reference to the one with provided name
    // create one if it does not exist
    value: function changeObserver(name, root) {
      this._factory.has(name) ? this._obKey = name : this.createObserver(name, root);
    } // add an observer with the provided root or null root
    // using default observer function
    // make the observer use the provided callback or default

  }, {
    key: "createObserver",
    value: function createObserver(name, root, callback) {
      var config = this.factory.config; // set the root element

      config.options.root = root ? root : null; // create the observer

      this.factory.createObserver(name, config, callback || this.obsFn);
    }
  }, {
    key: "startObserving",
    value: function startObserving(el, binding) {
      el.binding = binding;
      if (binding.isVue !== false) binding.isVue = true; // set the observer key

      el.observerKey = this.observerKey; // if a callback is specified, attach it

      if (hasCallback(el)) {
        var fn = genKey(el);
        el.setAttribute('ltr-id', fn);
        el.trId = fn;
        this.fnMap.set(fn, {
          onView: binding.onView,
          afterTransition: binding.afterTransition,
          onExit: binding.onExit
        });
      } // attach events if a transition is specified and addEvents is true


      if (binding.isVue && binding.transition) addTransitionEvents(el, 'enter', this.fnMap); // observe element

      this.observer.observe(el);
      clearCallbacks(el); // add observing attribute after observing

      el.setAttribute('lazy-observing', 'true');
    }
  }, {
    key: "observeWith",
    value: function observeWith(observer, el, binding) {
      var preObs = this._obKey;

      if (this.factory.has(observer)) {
        this._obKey = observer;
      }

      this.changeObserver(observer);
      this.startObserving(el, binding);
      this.changeObserver(preObs);
    }
  }, {
    key: "stopObserving",
    value: function stopObserving(el) {
      var _this$factory$getObse;

      // get the observer for the specific element
      (_this$factory$getObse = this.factory.getObserver(el.observerKey)) === null || _this$factory$getObse === void 0 ? void 0 : _this$factory$getObse.unobserve(el);
      el.removeAttribute('lazy-observing');
      el.removeAttribute('ltr-id');
    }
  }, {
    key: "disposeObserver",
    value: function disposeObserver(name) {
      this._factory.removeObserver(name || this.observerKey);
    }
  }, {
    key: "killAll",
    value: function killAll() {
      this._fnMap.clear();

      this._obKey = '';
      this.factory.deleteAll();
    }
  }, {
    key: "observer",
    get: function get() {
      return this._factory.getObserver(this.observerKey);
    }
  }, {
    key: "observerKey",
    get: function get() {
      return this._obKey;
    }
  }, {
    key: "fnMap",
    get: function get() {
      return this._fnMap;
    }
  }, {
    key: "factory",
    get: function get() {
      return this._factory;
    }
  }]);

  return ObserverService;
}();

function genKey(el) {
  var str = makeStr(5);
  return "".concat(el.observerKey, "-").concat(str);
}

function clearCallbacks(el) {
  el.binding.onView = undefined;
  el.binding.afterTransition = undefined;
  el.binding.onExit = undefined;
}

var defaultObserverConfig = {
  options: {
    root: null,
    rootMargin: '0px',
    threshold: [0.5, 0.75, 1]
  },
  intersectionRatio: 0
};

function initConfig(config) {
  if (config) {
    config.options.root = config.options.root || defaultObserverConfig.options.root;
    config.options.rootMargin = config.options.rootMargin || defaultObserverConfig.options.rootMargin;
    config.options.threshold = config.options.threshold || defaultObserverConfig.options.threshold;
    return config;
  }

  return defaultObserverConfig;
}

var createObserverService = function createObserverService(config) {
  config = initConfig(config);
  return new ObserverService(config);
};

// install function executed by Vue.use()
var install = function installLazyAnimate(Vue, config) {
  if (install.installed) return; // add global variable

  Vue.prototype.$lazyObserver = createObserverService(config);
  install.installed = true; // Add Component

  Vue.component('LazyTransition', __vue_component__); // Add Directive

  lazyAnimateDirective(Vue);
  lazyAnimateGroup(Vue);
  lazyTransitionRoot(Vue); //addMixin
  // addMixin(Vue)
}; // Create module definition for Vue.use()


var LazyTransitionPlugin = {
  install: install
}; // To auto-install when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(LazyTransitionPlugin);
} // Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
// eslint-disable-next-line @typescript-eslint/no-explicit-any


__vue_component__.install = install; //
//export installation objects

var entry = {
  Observer: ObserverService,
  install: install
}; // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default entry;
